import { http } from "@/core/ApiConfig";
import { Service } from "../shared/Service";

export class ConfiguracaoDiagnosticoFinalService extends Service {
    constructor() {
        super("v1/ConfiguracaoDiagnosticoFinal");
    }

    GetFirst() {
        return http.get(`${this.GetNomeControle()}/First`);
    }

    GetRelatorio() {
        return http.get(`${this.GetNomeControle()}/Relatorio`);
    }

    Patch(id: number, jsonPatchOps: any[]) {
        return http.patch(`${this.GetNomeControle()}/${id}`, jsonPatchOps, {
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        });
    }

    UploadCapa(id: number, file: File) {
        const formData = new FormData();
        formData.append("file", file);

        return http.post(`${this.GetNomeControle()}/${id}/Capa`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }

    GetCapa(id: number) {
        return http.get(`${this.GetNomeControle()}/${id}/Capa`, {
            responseType: "blob"
        });
    }
}
